import * as React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { NotificationProvider } from "./notification/notification_context";

import Navigation from "./navigation/navigation";

import Dashboard from "./dashboard/dashboard";
import Orders from "./orders/orders";
import Order from "./order/order";
import Promotion from "./promotion/promotion";
import Shop from "./shop/shop";
import Search from "./search/search";
import Contacts from "./contacts/contacts";
import Login from "./navigation/login";
import Logout from "./navigation/logout";
import Images from "./images/images";
import Settings from "./settings/settings";
import SiteSettings from "./site_settings/site_settings";

let router = createBrowserRouter([
  {
    path: "/",
    element: <Navigation />,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "orders", element: <Orders /> },
      { path: "order/:id", element: <Order /> },
      { path: "promotions", element: <Promotion /> },
      { path: "shop", element: <Shop /> },
      { path: "search", element: <Search /> },
      { path: "contacts", element: <Contacts /> },
      { path: "images", element: <Images /> },
      { path: "settings", element: <Settings /> },
      { path: "site_settings", element: <SiteSettings /> },
    ],
  },
  { path: "login", element: <Login /> },
  { path: "logout", element: <Logout /> },
]);

function App() {
  return (
    <div className="w-screen h-screen">
      <NotificationProvider>
        <RouterProvider router={router} />
      </NotificationProvider>
    </div>
  );
}
export default App;
